import angular from 'angular';
import uiRouter from 'angular-ui-router';
import Components from './components/components';
import AppComponent from './app.component';
import * as Sentry from '@sentry/browser';
import { Angular as AngularIntegration } from "@sentry/integrations";
import npmConfig from '../../package.json';

import 'normalize.css';
import { getEnv } from './common/clickstream/schemas/clickstream-util';
import ErrorService from './components/error/error.service';

Sentry.init({
  dsn: getEnv() === 'prod' ? 'https://a39671fc5cfe40e5b56092cb91ca8f69@o18760.ingest.sentry.io/4504532338671616' : 'https://302211aa774e4d5094a5bd21820cd2bc@o18760.ingest.sentry.io/4504532334804992',
  environment: getEnv(),
  release: npmConfig.version,
  beforeSend: ErrorService.hydrateSentryEvent,
  ignoreErrors: [
    // Following errors appear to stem from a Safari extension(s)
    // which is why we're ignoring them.
    "t.logger[e] is not a function",
    "2 arguments for sendNativeMessage(), got 3",
    "safari-web-extension://",
    "Error executing track"
  ],
  integrations: [new AngularIntegration()],
});

angular.module('app', [
    uiRouter,
    Components,
    "ngSentry"
  ])
  .config(($locationProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');
  })
  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js